function onUnhandledRequest(request: Request) {
  if (request.url.includes("_next")) {
    // Prevent Next's internal requests for resources from being noticed by MSW
    return;
  }
}

export async function initServerMocks() {
  const { server } = await import("./server");
  server.listen({
    onUnhandledRequest,
  });
}

export async function initBrowserMocks() {
  const { worker } = await import("./browser");
  await worker.start({
    onUnhandledRequest,
    serviceWorker: {
      // Specify the worker script URL relative to the _root_.
      url: "/research/mockServiceWorker.js",
      options: {
        // Override the scope to the root ("/").
        // By default, the worker is scoped to its location on your server,
        // which in this case would be "/prefix".
        scope: "/",
      },
    },
  });

  window.addEventListener("beforeunload", async () => {
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      registrations.forEach((registration) => {
        if (registration.scope.includes("/mockServiceWorker.js")) {
          registration.unregister();
        }
      });
    }
  });
}
